import styled from '@emotion/styled';

import inviaLogo from '@/assets/images/cross-border-invia-logo.svg?no-inline';

export const InviaLogo = styled.span`
  color: transparent;
  background: url('${inviaLogo}') no-repeat;
`;
